import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../header';
import Footer from '../../footer';
import { HiOutlineArrowLeft, HiOutlineScale } from 'react-icons/hi';

export default function TermsOfService() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#FAFDFB] min-h-screen text-[#1E293B]">
            <Header />

            <main className="pt-[140px] sm:pt-[170px] pb-[80px] px-[16px] sm:px-[24px] lg:px-[40px] max-w-[1080px] mx-auto">
                {/* Back to Home Link */}
                <Link 
                    to="/" 
                    className="inline-flex items-center gap-2 text-[#73C8BD] hover:text-[#5ebcae] font-semibold text-[14px] sm:text-[15px] mb-8 group transition-colors"
                >
                    <HiOutlineArrowLeft className="group-hover:-translate-x-1 transition-transform" />
                    <span>Back to Home</span>
                </Link>

                {/* Page Header */}
                <div className="border-b border-gray-200 pb-8 mb-10">
                    <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#EBF7EE] text-[#00B884] text-[13px] font-bold tracking-wide uppercase mb-3">
                        <HiOutlineScale className="text-[18px]" />
                        <span>Legal Terms</span>
                    </div>
                    <h1 className="text-[32px] sm:text-[42px] lg:text-[48px] font-extrabold text-[#0F172A] tracking-tight">
                        Terms of Service
                    </h1>
                    <p className="text-gray-500 text-[14px] sm:text-[15px] mt-2">
                        Last Updated: March 2026 &bull; Rainbow Trucks Private Limited
                    </p>
                </div>

                {/* Content Sections */}
                <div className="prose prose-slate max-w-none space-y-10 text-[15px] sm:text-[16px] leading-relaxed text-[#334155]">
                    
                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            1. Agreement to Terms
                        </h2>
                        <p>
                            Welcome to the website of <strong>Rainbow Trucks Private Limited</strong> (<strong>"Rainbow Trucks"</strong>, <strong>"Company"</strong>, <strong>"we"</strong>, <strong>"us"</strong>, or <strong>"our"</strong>). By accessing or using our website (<code>rainbowtrucks.com</code>) or submitting inquiries for our franchise programs, you agree to comply with and be bound by these Terms of Service (<strong>"Terms"</strong>). If you do not agree with these Terms, please refrain from using our website and services.
                        </p>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            2. Corporate Identity & Registered Office
                        </h2>
                        <p>
                            Rainbow Trucks Private Limited is a registered Indian company incorporated under the laws of India, with its corporate office situated at:
                        </p>
                        <p className="mt-2 text-gray-800 font-medium">
                            10th Street, Ram Nagar, Puzhuthivakkam, Madipakkam, Chennai, Tamil Nadu 600091, India.
                        </p>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            3. Franchise Inquiries & Commercial Relationships
                        </h2>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li><strong>Informational Content:</strong> Information provided on this website regarding cart models, pricing tiers (Economy, Mid-Range, Premium), expected revenue, and margins is provided for general informational and illustrative purposes.</li>
                            <li><strong>Formal Franchise Agreements:</strong> Formal partnership and territorial allocation are governed solely by legally binding written Franchise Agreements entered into between Rainbow Trucks Private Limited and the franchisee.</li>
                            <li><strong>Product Quality:</strong> Franchise partners agree to adhere strictly to authorized food safety, hygiene, and brand guidelines when distributing Rainbow Trucks artisanal kulfis.</li>
                        </ul>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            4. Intellectual Property Rights
                        </h2>
                        <p>
                            All trademarks, brand names, logos, recipes, trade secrets, design graphics, and website content are the exclusive intellectual property of <strong>Rainbow Trucks Private Limited</strong>. No content from this website may be copied, reproduced, modified, distributed, or used for commercial purposes without prior written authorization from the Company.
                        </p>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            5. Disclaimers & Limitation of Liability
                        </h2>
                        <p>
                            While Rainbow Trucks provides comprehensive training, operational systems, and high-quality product supply, actual business performance and returns depend upon local footfall, location selection, franchisee working hours, and market factors. The Company does not guarantee specific earnings.
                        </p>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            6. Governing Law & Jurisdiction
                        </h2>
                        <p>
                            These Terms of Service and any disputes arising out of or related to this website or our franchise offerings shall be governed by and construed in accordance with the laws of India. Courts located in <strong>Chennai, Tamil Nadu, India</strong> shall have exclusive jurisdiction.
                        </p>
                    </section>

                    <section className="bg-white p-6 sm:p-8 rounded-[20px] border border-gray-100 shadow-sm">
                        <h2 className="text-[20px] sm:text-[22px] font-bold text-[#0F172A] mb-3">
                            7. Contact & Legal Notices
                        </h2>
                        <p>
                            For legal inquiries, formal notices, or questions concerning these Terms, please contact:
                        </p>
                        <div className="mt-4 p-4 rounded-xl bg-gray-50 border border-gray-200 text-[14px] leading-relaxed">
                            <p><strong>Legal Department:</strong> Rainbow Trucks Private Limited</p>
                            <p><strong>Address:</strong> 10th Street, Ram Nagar, Puzhuthivakkam, Madipakkam, Chennai, Tamil Nadu 600091, India</p>
                            <p><strong>Email:</strong> <a href="mailto:hello@rainbowtrucks.com" className="text-[#73C8BD] font-semibold underline">hello@rainbowtrucks.com</a></p>
                            <p><strong>Helpline:</strong> +91 99399 35343</p>
                        </div>
                    </section>

                </div>
            </main>

            <Footer />
        </div>
    );
}
